import {useMemo} from 'react'
import {type PlayerColor} from '@colonist/game-states'
import {type UIGamePlayerInfoSectionContentCKProps} from '../../UIGamePlayerInfo/index.ts'
import {useMechanicValidatorCityImprovements} from '../../../store/selectors/useMechanicValidatorCityImprovements.ts'
import {useMechanicValidatorProgressCards} from '../../../store/selectors/useMechanicValidatorProgressCards.ts'
import {cardEnumsToCardState} from '../../../utils/cards.ts'
import {CardDataController} from '@colonist/game-card-types'

export const usePlayerInfoSectionContentCKProps = (playerColor: PlayerColor) => {
    const progressCardsValidator = useMechanicValidatorProgressCards()
    const cityImprovementsValidator = useMechanicValidatorCityImprovements()

    const progressCardsPlayerHand = progressCardsValidator?.getProgressCardsPlayerValidator(playerColor).progressCards.cards
    if(progressCardsPlayerHand == undefined) return null

    const cityImprovementPlayerState = cityImprovementsValidator?.getPlayerCityImprovementsState(playerColor)
    if(cityImprovementPlayerState == undefined) return null

    return useMemo<UIGamePlayerInfoSectionContentCKProps>(() => {
        const progressCardBacks = CardDataController.getCardBacksForCards(progressCardsPlayerHand)
        const progressCardStateUnordered = cardEnumsToCardState(progressCardBacks)
        return {
            progressCardState: progressCardStateUnordered,
            cityImprovementState: cityImprovementPlayerState,
        }
    }, [progressCardsPlayerHand, cityImprovementPlayerState])
}
